import { useEffect, useState } from "react";
import { Trash2, Check } from "lucide-react";
import { toast } from "sonner";
import { adminContacts, adminUpdateContact, adminDeleteContact } from "@/lib/api";
import { AdminHeader } from "./ui";

export default function AdminContacts() {
  const [items, setItems] = useState([]);
  const load = () => adminContacts().then(setItems);
  useEffect(() => { load(); }, []);

  const markDone = async (c) => { await adminUpdateContact(c.id, { estado: "RESPONDIDO" }); toast.success("Marcado como respondido."); load(); };
  const remove = async (c) => { if (!window.confirm("¿Eliminar mensaje?")) return; await adminDeleteContact(c.id); toast.success("Eliminado."); load(); };

  return (
    <div>
      <AdminHeader title="Contactos" subtitle={`${items.length} mensaje(s)`} />
      <div className="space-y-3">
        {items.map((c) => (
          <div key={c.id} className="rounded-xl bg-white border border-[#0f2544]/8 p-5" data-testid={`contact-row-${c.id}`}>
            <div className="flex items-start justify-between gap-4">
              <div className="flex-1">
                <div className="flex items-center gap-3">
                  <span className="font-medium text-[#0f2544]">{c.nombre} {c.apellidos}</span>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-[#eceae4] text-[#1f44e0]">{c.motivo}</span>
                  <span className={`text-xs ${c.estado === "PENDIENTE" ? "text-amber-600" : "text-green-600"}`}>{c.estado}</span>
                </div>
                <div className="text-xs text-[#8a8a83] mt-1">{c.email} {c.pais && `· ${c.pais}`} · {new Date(c.fecha).toLocaleDateString()}</div>
                <p className="text-sm text-[#4a4a45] mt-2 whitespace-pre-line">{c.mensaje}</p>
              </div>
              <div className="flex gap-1 shrink-0">
                {c.estado === "PENDIENTE" && <button onClick={() => markDone(c)} className="p-2 text-[#8a8a83] hover:text-green-600" title="Marcar respondido"><Check size={16} /></button>}
                <button onClick={() => remove(c)} className="p-2 text-[#8a8a83] hover:text-red-600"><Trash2 size={16} /></button>
              </div>
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="rounded-xl bg-white border border-[#0f2544]/8 py-16 text-center text-[#8a8a83]">Sin mensajes.</div>}
      </div>
    </div>
  );
}
